// This file is generated by a script. Do not edit this file directly.
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["className", "size", "variant", "fallbackColor", "style", "fallbackClassName", "useNewColors"],
  _excluded2 = ["className"],
  _excluded3 = ["className"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from 'react';
import * as AvatarPrimitive from '@radix-ui/react-avatar';
import { cva } from 'cva';
import { cn, ensureUnreachable } from "../../common/utils";
import { Heading } from "../Typography";
import { Icon } from "../Icon";
var avatarFallbackVariants = cva({
  variants: {
    fallbackColor: {
      teal: 'cop-bg-teal-primary-light cop-text-teal-primary-dark',
      cyan: 'cop-bg-cyan-primary-light cop-text-cyan-primary-dark',
      amber: 'cop-bg-amber-primary-light cop-text-amber-primary-dark',
      rose: 'cop-bg-rose-primary-light cop-text-rose-primary-dark',
      violet: 'cop-bg-violet-primary-light cop-text-violet-primary-dark',
      gray: 'cop-bg-avatar-gray cop-text-p-text-primary',
      purple: 'cop-bg-purple-primary-light cop-text-purple-primary-dark',
      olive: 'cop-bg-olive-primary-light cop-text-olive-primary-dark'
    }
  }
});
function getBorderRadius(size, variant) {
  if (variant === 'circle') {
    return 'cop-rounded-full';
  }
  switch (size) {
    case '3xs':
    case '2xs':
    case 'xs':
    case 'sm':
      return 'cop-rounded';
    case 'md':
      return 'cop-rounded';
    case 'lg':
      return 'cop-rounded-md';
    case 'xl':
      return 'cop-rounded-lg';
    default:
      ensureUnreachable(size);
  }
}
var PREDEFINED_COLORS = ['teal', 'cyan', 'amber', 'rose', 'violet', 'gray', 'purple', 'olive'];
var legacyFallbackColorToNewColorsMap = {
  '#56351E': {
    fontColor: '#7E5437',
    bgColor: '#F1EDEA'
  },
  '#EC4E20': {
    fontColor: '#ED7C58',
    bgColor: '#FFF2E3'
  },
  '#7CAE7A': {
    fontColor: '#75876E',
    bgColor: '#EBF3E7'
  },
  '#AF4D98': {
    fontColor: '#7A2D87',
    bgColor: '#FAEEFB'
  },
  '#5E0B15': {
    fontColor: '#894D54',
    bgColor: '#EBE1E2'
  }
};
var getTextColorFromFallbackColor = function getTextColorFromFallbackColor(color) {
  var colorHex = color.replace('#', '');
  var r = parseInt(colorHex.substr(0, 2), 16);
  var g = parseInt(colorHex.substr(2, 2), 16);
  var b = parseInt(colorHex.substr(4, 2), 16);
  var brightness = (r * 299 + g * 587 + b * 114) / 1000;
  return brightness >= 128 ? 'var(--p-text-primary)' : '#FFFFFF';
};
var Avatar = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size,
    variant = _ref.variant,
    _ref$fallbackColor = _ref.fallbackColor,
    fallbackColor = _ref$fallbackColor === void 0 ? 'gray' : _ref$fallbackColor,
    style = _ref.style,
    fallbackClassName = _ref.fallbackClassName,
    _ref$useNewColors = _ref.useNewColors,
    useNewColors = _ref$useNewColors === void 0 ? false : _ref$useNewColors,
    props = _objectWithoutProperties(_ref, _excluded);
  // Reference: https://www.figma.com/design/HH25FbLn13q9qx5uDCFxYI/%F0%9F%A7%A9-Design-System?node-id=17964-63334&t=6X02LBImhNYSillh-0
  var AVATAR_SIZE_MAP = {
    '3xs': 'cop-h-3 cop-w-3',
    // 12px
    '2xs': 'cop-h-4 cop-w-4',
    // 16px
    xs: 'cop-h-5 cop-w-5',
    // 20px
    sm: 'cop-h-6 cop-w-6',
    // 24px
    md: 'cop-h-8 cop-w-8',
    // 32px
    lg: 'cop-h-10 cop-w-10',
    // 40px
    xl: 'cop-h-16 cop-w-16' // 64px
  };
  var AVATAR_ICON_SIZE_MAP = {
    '3xs': 'cop-h-[8px] cop-w-[8px]',
    '2xs': 'cop-h-[10px] cop-w-[10px]',
    xs: 'cop-h-[10px] cop-w-[10px]',
    sm: 'cop-h-[14px] cop-w-[14px]',
    md: 'cop-h-[18px] cop-w-[18px]',
    lg: 'cop-h-6 cop-w-6',
    xl: 'cop-h-7 cop-w-7'
  };
  var avatarSize = AVATAR_SIZE_MAP[size];
  var avatarSizeWithBorder = "".concat(avatarSize, " ").concat(getBorderRadius(size, variant));
  var TEXT_SIZE_MAP = {
    '3xs': '3xs',
    '2xs': '2xs',
    xs: 'xs',
    sm: 'xs',
    md: 'sm',
    lg: 'lg',
    xl: '2xl'
  };

  // Check if fallbackColor is a predefined variant or custom hex color
  var isAvatarFallbackColor = function isAvatarFallbackColor(color) {
    return PREDEFINED_COLORS.includes(color);
  };

  // For custom hex colors, use inline styles (legacy support)
  var customColorStyles = React.useMemo(function () {
    if (fallbackColor && !isAvatarFallbackColor(fallbackColor) && 'src' in props && !props.src) {
      var _legacyFallbackColorT, _legacyFallbackColorT2;
      return _objectSpread({
        backgroundColor: useNewColors ? (_legacyFallbackColorT = legacyFallbackColorToNewColorsMap[fallbackColor]) === null || _legacyFallbackColorT === void 0 ? void 0 : _legacyFallbackColorT.bgColor : fallbackColor,
        color: useNewColors ? (_legacyFallbackColorT2 = legacyFallbackColorToNewColorsMap[fallbackColor]) === null || _legacyFallbackColorT2 === void 0 ? void 0 : _legacyFallbackColorT2.fontColor : getTextColorFromFallbackColor(fallbackColor)
      }, style);
    }
    return style !== null && style !== void 0 ? style : {};
  }, [fallbackColor, style, props]);
  return /*#__PURE__*/React.createElement(AvatarPrimitive.Root, _extends({
    ref: ref,
    className: cn("cop-relative cop-flex cop-border cop-border-solid cop-border-card-border ".concat(avatarSizeWithBorder, " cop-shrink-0 cop-overflow-hidden"),
    // Apply CVA variant classes only for predefined colors when image is not loaded
    isAvatarFallbackColor(fallbackColor) && avatarFallbackVariants({
      fallbackColor: fallbackColor
    }), {
      'cop-bg-avatar-gray': !!props.icon || 'src' in props && !!props.src
    }, className),
    style: customColorStyles
  }, props), 'src' in props && /*#__PURE__*/React.createElement(AvatarImage, {
    src: props.src,
    alt: props.alt
  }), 'text' in props && !props.icon && /*#__PURE__*/React.createElement(AvatarFallback, null, /*#__PURE__*/React.createElement(Heading, {
    size: TEXT_SIZE_MAP[size],
    className: fallbackClassName
  }, props.text)), props.icon && /*#__PURE__*/React.createElement(AvatarFallback, null, /*#__PURE__*/React.createElement(Icon, {
    icon: props.icon,
    className: AVATAR_ICON_SIZE_MAP[size]
  })));
});
Avatar.displayName = AvatarPrimitive.Root.displayName;
var AvatarImage = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var className = _ref2.className,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(AvatarPrimitive.Image, _extends({
    ref: ref,
    className: cn('cop-aspect-square cop-h-full cop-w-full', className)
  }, props));
});
AvatarImage.displayName = AvatarPrimitive.Image.displayName;
var AvatarFallback = /*#__PURE__*/React.forwardRef(function (_ref3, ref) {
  var className = _ref3.className,
    props = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/React.createElement(AvatarPrimitive.Fallback, _extends({
    ref: ref,
    className: cn('cop-bg-muted cop-flex cop-h-full cop-w-full cop-items-center cop-justify-center cop-rounded-full', className)
  }, props));
});
AvatarFallback.displayName = AvatarPrimitive.Fallback.displayName;
export { Avatar };
